import { render, staticRenderFns } from "./sxyProductForm.vue?vue&type=template&id=1efc2086&"
import script from "./sxyProductForm.vue?vue&type=script&lang=js&"
export * from "./sxyProductForm.vue?vue&type=script&lang=js&"
import style0 from "./sxyProductForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports